import React from 'react';
import PayBillsEnterCodeDF from '../components/SimulatorsComponents/DefualtSimulators/PayBillsEnterCodeDF';

//= ========================================================================
const Sim_D02_PayBillsEnterCode = ({
  globJSON,
  selectedScreen,
  simPlatform,
  slideshowRefs = null,
}) => (
  <PayBillsEnterCodeDF
    globJSON={globJSON}
    selectedScreen={selectedScreen}
    simPlatform={simPlatform}
    slideshowRefs={slideshowRefs}
  />
);

export default Sim_D02_PayBillsEnterCode;
